'use client'
import type { DefaultCellComponentProps } from 'payload'

import { etichettaStato } from '@/negozio/ordini/stati'

import './ordini.scss'

/** List cell for `stato` and `statoPagamento`: a coloured pill (colour per value, see SCSS). */
export const StatoBadge: React.FC<DefaultCellComponentProps> = ({ cellData }) => {
  if (typeof cellData !== 'string' || !cellData) return null
  return (
    <span className={`stato-badge stato-badge--${cellData}`} data-stato={cellData}>
      {etichettaStato(cellData)}
    </span>
  )
}
